import React, { useState } from 'react';
import Axios from 'axios';
import { useHistory } from 'react-router-dom';
import { notificationError, notificationSuccess } from '../../../../core/actions';
import { API_URL } from '../../../../constants';

// Official Clientbook Logo URL
const CLIENTBOOK_LOGO_URL = 'https://cdn.prod.website-files.com/5f15c00e4ffd49ccdceda3e2/66f5272d6da01e9c089a0165_Clientbook%20logo%202.svg';

const ResetPassword = () => {
  const history = useHistory();
  const [email, setEmail] = useState('');

  const sendPwReq = () => {
    const validEmail = emailValidation(email);
    if (emailValidation(email)) {
      Axios.post(`${API_URL}/resetPassword?email=${email.toLowerCase()}`)
        .then(resp => {
          notificationSuccess('Reset Password Email Sent');
          history.push('/Login');
        })
        .catch(err => {
          console.error('[ResetPassword] Error in ResetPassword request: ', err);
          if (err.response && err.response.data && err.response.data.message) {
            // notificationError(err.response.data.message);
          }
        });
    }
  };

  const emailValidation = email => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return true;
    }
    notificationError('Enter valid email address!');
    return false;
  };

  const currentYear = new Date().getFullYear();

  return (
    <div className="login-page-light">
      {/* Centered card container */}
      <div className="login-card">
        {/* Logo */}
        <img
          src={CLIENTBOOK_LOGO_URL}
          alt="Clientbook"
          className="login-card-logo"
        />

        {/* Header text */}
        <h1 className="login-card-title">Reset password</h1>
        <p className="login-card-subtitle" style={{ maxWidth: '320px' }}>
          Enter your email address and we'll send you instructions to reset your password.
        </p>

        {/* Email input */}
        <input
          type="email"
          value={email}
          placeholder="Email address"
          onChange={e => setEmail(e.target.value)}
          className="reset-card-input"
          onKeyPress={e => e.key === 'Enter' && sendPwReq()}
        />

        {/* Buttons */}
        <div className="reset-card-buttons">
          <button
            onClick={() => history.push('/Login')}
            className="reset-card-cancel"
          >
            Cancel
          </button>
          <button
            onClick={sendPwReq}
            className="reset-card-submit"
          >
            Send reset email
          </button>
        </div>
      </div>

      {/* Footer */}
      <div className="login-page-footer">
        <span>© {currentYear} Clientbook</span>
        <span className="login-footer-dot">·</span>
        <a href="https://help.clientbook.com/en/" target="_blank" rel="noopener noreferrer">
          Help
        </a>
        <span className="login-footer-dot">·</span>
        <a href="https://clientbook.com/privacy" target="_blank" rel="noopener noreferrer">
          Privacy
        </a>
      </div>
    </div>
  );
};

export default ResetPassword;
